import {
  getLevelList,
  pathCreateLevel,
  pathDeleteLevel,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { levelActions } from "../reducers/level";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchLevelList = (id_level = 0) => {
  return (dispatch) => {
    return apiService
      .get(getLevelList(id_level))
      .then((response) => {
        id_level == 0
          ? dispatch(levelActions.fetchLevelList(response.data))
          : dispatch(levelActions.fetchLevelDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createNewLevel = (data, navigate) => {
  return async () => {
    try {
      const response = await apiService.postMultipart(pathCreateLevel(), data);
      navigate("/level-list");
      toast.success(t("levelListActions.created"), { theme: "colored" });
    } catch (err) {
      handleError(err);
    }
  };
};

export const createNewLevel1 = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .postMultipart(pathCreateLevel(), data)
      .then((response) => {
        // dispatch(levelActions.fetchLevelList(response.data));
        toast.success(t("levelListActions.created"), {
          theme: "colored",
        });
        navigate("/level-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditLevel = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .putMultipart(pathCreateLevel(), data)
      .then((response) => {
        // dispatch(levelActions.fetchLevelList(response.data));
        toast.success(t("levelListActions.updated"), {
          theme: "colored",
        });
        navigate("/level-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteLevel = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeleteLevel(id))
      .then((response) => {
        toast.success(t("levelListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchLevelList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
